import { render, staticRenderFns } from "./BlogWidget.vue?vue&type=template&id=6b583a51&scoped=true"
import script from "./BlogWidget.vue?vue&type=script&lang=js"
export * from "./BlogWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b583a51",
  null
  
)

export default component.exports